import styled from 'styled-components';

export const StyledTitle = styled.h2<{darkened: boolean}>`
  font-family: ${({ theme }) => theme.fontFamily.special};
  font-size: 48px;
  color: ${({ theme, darkened }) => darkened ? theme.colors.white : theme.colors.primary};
  font-weight: 900;
  margin-top: 0;
  margin-bottom: 36px;
  line-height: 1.1;
`;
